var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative" },
    [
      _c(
        "div",
        {
          directives: [{ name: "init-code", rawName: "v-init-code" }],
          staticClass: "code__render"
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "code__toggle",
          attrs: { href: "javascript:" },
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.isOpen ? "Hide" : "Show") +
              " HTML\n        "
          ),
          _c("span", [_vm._v(_vm._s(_vm.isOpen ? "-" : "+"))])
        ]
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ]
          },
          [_c("pre", [_c("code", { staticClass: "html" })])]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }